// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AnimatedHeadline_wrapper__ZgrwP","word":"AnimatedHeadline_word__WxdZk","separator":"AnimatedHeadline_separator__SKPNx"};